import { render } from "./View.vue?vue&type=template&id=601c340c&ts=true&lang=pug"
import script from "./View.vue?vue&type=script&setup=true&lang=ts"
export * from "./View.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__